module.exports = __webpack_public_path__ + "img/back.39b4daa6.png";